import apiClient from 'apiClient';
import cachedValidateRequest from './cachedValidateRequest';
import { ValidationResponse, ValidationStatuses } from './types';

export class CheckScotlandRegionAvailabilityError extends Error {}

const validate = async (postCode: string): Promise<ValidationResponse> => {
  const response = await apiClient.post('/api/v1/business-rules/validate-scotland-region-availability/', {
    postCode,
  });

  if (response.data.status !== ValidationStatuses.OK) {
    throw new CheckScotlandRegionAvailabilityError(response.data.details);
  }

  return response.data;
};

const cachedValidate = async (postcode: string) => {
  return cachedValidateRequest(async () => {
    return await validate(postcode);
  }, `validate-scotland-region-availability-${postcode}`);
};

const exportObject = { validate, cachedValidate };

export default exportObject;
